

































import AbpBase from '@/lib/abpbase'
import { Component , Prop} from 'vue-property-decorator'
import PageRequest from '@/store/entities/page-request'
import Link from '@/store/entities/link'
import { EventBus } from '@/lib/eventbus';
@Component
export default class PickUrl extends AbpBase {
    @Prop({ type: Number, required: true }) type!: number;
    pagerequest:PageRequest=new PageRequest();
    collapseVal:string="2";
    link:Link = new Link();
    add(){    
        if(this.type = 1){
            this.link.target= "_blank";
        }
        console.log(this.link.type);    
        this.create();
    }
    checkExternal(value){
        if(value){
            this.link.target = "_blank";
        }else{
            this.link.target = "";
        }
    }
    async create(){
        (this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'links/create',
                    data:this.link
                }).then( () =>{
                    this.link = new Link();
                    if(this.type = 0){
                        EventBus.$emit('createMenuLink');
                    }else{
                        EventBus.$emit('createLink');
                    }                
                    this.getpage();
                });
            }
        });
    }
    getpage(){
        
    }
    mounted(){
        this.link.external = true;
        this.link.type = this.type;  
    }
    async created(){
        
    }
    rules= {
        name: [
            { required: true, message: this.L('PleasefillName'), trigger: 'blur' }
        ],
        url: [
            { required: true, message: this.L('PleasefillUrl'), trigger: 'blur' }
        ]
    }
};
